"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupIcon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var GroupIcon = function GroupIcon(_ref) {
  var color = _ref.color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 24 : _ref$width,
      props = _objectWithoutProperties(_ref, ["color", "height", "width"]);

  return _react2.default.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: color,
    height: height,
    width: width
  }, props), _react2.default.createElement("defs", null, _react2.default.createElement("path", {
    d: "M45.917 47.73H7.25a6.646 6.646 0 0 1-6.646-6.647V7.25A6.646 6.646 0 0 1 7.25.604h12.083c.601.001 1.162.3 1.499.798l4.301 6.452h20.784a6.646 6.646 0 0 1 6.645 6.646v26.583a6.646 6.646 0 0 1-6.645 6.646zM7.25 4.23a3.02 3.02 0 0 0-3.02 3.02v33.833a3.02 3.02 0 0 0 3.02 3.021h38.667a3.02 3.02 0 0 0 3.02-3.02V14.5a3.02 3.02 0 0 0-3.02-3.02h-21.75a1.764 1.764 0 0 1-1.499-.798l-4.301-6.453H7.25z",
    id: "GroupIcon_svg__a"
  })), _react2.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react2.default.createElement("path", {
    d: "M6 0h88a6 6 0 0 1 6 6v88a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z",
    fill: "#6E747C",
    fillRule: "nonzero"
  }), _react2.default.createElement("g", {
    transform: "translate(23.417 25.833)"
  }, _react2.default.createElement("mask", {
    id: "GroupIcon_svg__b",
    fill: "#fff"
  }, _react2.default.createElement("use", {
    xlinkHref: "#GroupIcon_svg__a"
  })), _react2.default.createElement("g", {
    mask: "url(#GroupIcon_svg__b)",
    fill: "#F3F5F7"
  }, _react2.default.createElement("path", {
    d: "M-2.417-7.25h58v58h-58z"
  })))));
};

exports.GroupIcon = GroupIcon;